"use strict";
import EventEmitter from 'eventemitter2';
import Browser from './../util/browser';

class BtnBase extends EventEmitter{
	constructor($con){
		super();
		this.$con = $con;
		this.$con.data('text' , this.$con.text());
		this.isHover = false;
		this.init();

		Browser.addResponsiveHandler(this.responsiveHandler , this);
		this.responsiveHandler();
		
		this.$con.on('click',this.click.bind(this));
	}
	
	init(){
	}
	
	responsiveHandler(){
		this.$con.off('.pc');
		if( Browser.responsive == 'pc' ){
			this.$con.on('mouseenter.pc',this.over.bind(this));
			this.$con.on('mouseleave.pc',this.out.bind(this));
		} else {
			
		}
	}

	over(){
		if(Browser.isiPad) return;
		this.isHover = true;
	}
	out(){
		if(Browser.isiPad) return;
		this.isHover = false;
	}
	click(){
		this.emit('click',this);
	}
}

export default BtnBase;


// WEBPACK FOOTER //
// ./js/btn/btnbase.js